export const USDT_ADDRESS = "0xBF4fD550c7BD3Cf6eC6A0b30bD4c8e603bbC16a8"
export const SC_ADDRESS = "0xb601471824d2752433568499a064Ef92Fe9517cB"
